module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/8-68f48cffca5a494eb05d3193cf02bd37.png";